<template>
  <div class="px-7" ref="subMenuPesticidesRef">
    <v-btn-toggle
      v-model="optionSelected"
      mandatory
      style="border: 1px solid #95a1ec"
      background-color="#212a35"
      :class="width > 300 ? 'd-flex flex-row' : 'd-flex flex-column'"
    >
      <v-btn
        :value="'Pastagens'"
        color="#95A1EC"
        height="28"
        class="btn-group flex-grow-1"
      >
        Pastagens
      </v-btn>
      <v-btn
        :value="'Agricultura'"
        color="#95A1EC"
        height="28"
        class="btn-group flex-grow-1"
      >
        Agricultura
      </v-btn>
      <v-btn
        :value="'Silvicultura'"
        color="#95A1EC"
        height="28"
        class="btn-group flex-grow-1"
      >
        Silvicultura
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'SubMenuLayerPesticides',
  props: ['layer', 'group'],
  data: () => ({
    optionSelected: undefined,
    width: 0,
    observer: null,
  }),
  mounted() {
    this.observer = new ResizeObserver(this.handleResize);
    this.observer.observe(this.$refs.subMenuPesticidesRef);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  watch: {
    optionSelected() {
      this.changeLayersOfPesticides();
    },
  },
  methods: {
    handleResize(entries) {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.width = width;
      }
    },
    changeLayersOfPesticides() {
      if (this.optionSelected == 'Pastagens') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 501},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 502},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 500},
        });
      }
      if (this.optionSelected == 'Agricultura') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 500},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 502},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 501},
        });
      }
      if (this.optionSelected == 'Silvicultura') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 500},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 501},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 502},
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12.0833px;
  line-height: 15px;
  text-transform: none;
  color: #95a1ec;
  border: 1px solid #95a1ec;
}

::v-deep .theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #95a1ec !important;
}

::v-deep .v-btn-toggle > .v-btn.v-btn--active {
  color: #95a1ec !important;
  opacity: 1;
}

::v-deep .theme--dark.v-btn.v-btn--has-bg {
  background-color: #212a35 !important;
}
</style>
